module.exports = __webpack_public_path__ + "static/media/whatsapp_white.e25cd520.svg";